import ResourcesCollectionProto from "./resources-collection-proto"
import Resources from "../resources"
import Expense from "../../model2/expenses/expense/expense"
import Collection, {ModelInterface} from "../../data-structures/collection"
import {UpdateAction, UpdateType} from "../../gd/manager/delta-handler/types";
import exportToCsv from "../../gd-modules/export-to-csv/export-to-csv";

// const debug = "ExpensesResourcesCollection"
const debug = false

export default class ExpensesResourcesCollection extends ResourcesCollectionProto {

    constructor(resources:Resources, data: any[], options:any={}) {
        super(resources, data, Expense, options)
    }

    get total():number {
        let total = 0

        this.models.map((expense: Expense)=>{
            total += expense.total
        })

        return total
    }

    get byUser(): Collection<ExpenseByUser> {
        const res = new Collection(_(this.models)
            .groupBy(t=>t.userId)
            .toPairs()
            .map(g=>new ExpenseByUser({
                userId: g[0],
                amount: _.sum(_.map(g[1], (model:Expense)=>model.amount))
            }))
            .value())

        debug && console.log(debug, 'byUser', res)

        return res
    }

    processUpdate(update:UpdateAction):boolean {
        debug && console.log(debug, "processUpdate()", update)

        // New
        if (update.updateType === UpdateType.EXPENSE_NEW) {

            const expense : Expense = new Expense(update.payload)
            this.add(expense)

            return true // collection changed
        }

        // Change/Delete
        const expense: Expense | undefined = this.get(update.payload.id)

        // not found ? -> no update
        if (!expense) {
            return false
        }

        if (update.updateType === UpdateType.EXPENSE_DELTA) {
            return expense.applyDelta(update.payload)
        }

        if (update.updateType === UpdateType.EXPENSE_DELETE) {
            this.remove(update.payload.id)
            return true // deleted = changed
        }

        // should never get heres
        return false // not changed
    }

    exportToCSV(arrayOfFields: any[], arrayOfIds: string[] = [], fileName: string = 'expenses'): void {
        debug && console.log(debug, 'exportToCSV', arrayOfFields, arrayOfIds, fileName)

        const list: any[] = []
        // csv header
        const header: string[] = ['Id'] // id always present and is first
        _.map(arrayOfFields, field=>{
            header.push(field.label)
        })
        list.push(header)

        // iterate through models to get export info for each required
        _(this.models)
            .filter(model=>_.isEmpty(arrayOfIds) || arrayOfIds.includes(model.id)) // filter according to arrayOfIds if any
            .map(model=>{ // add row for each resource item
                const values: any[] = [model.id] // id always present and is first

                _.map(arrayOfFields, field=>{
                    values.push(field.normalizeToCSVValue(model))
                })

                list.push(values)
            })
            .value()

        exportToCsv(list, '{0}.csv'.f(fileName))
    }


}

export class ExpenseByUser implements ModelInterface {
    id: ID
    userId: ID
    amount: number

    constructor(data:any) {
        this.id     = data.userId
        this.userId = data.userId
        this.amount = data.amount
    }

    toJSON() {
        return {
            id      : this.id,
            userId  : this.userId,
            amount  : this.amount
        }
    }
}
